// extracted by mini-css-extract-plugin
export default {"property_owner_container":"style_property_owner_container__0rvr9","no_margin":"style_no_margin__bczyX"};